import React, { useContext, useEffect, useState } from "react";
import { notification, Pagination } from "antd";
import { userServices, deliveriesService, Filters } from "../../../services";
import { deliveriesConfig } from "../../../config";
import Spinner from "../../spinner";
import { AppContext } from "../../../contexts/app-context"
import { VIEW_AGREED_DELIVERIES_LOGIST } from "../../../helpers/user_permission.helper";
import { DELIVERY_AWAITING_LOADING } from "../../../helpers/delivery_status.helper";
import DeliveryItemBlock from "../../delivery-item-block";
import UnloadingItemBlock from "../../unloading-item-block";
import LogistFreeContentItem from "../../delivery-item-content/logist/free-content-item";
import DeterminedPrice from "../../determined-price";
import moment from "moment";
import UserNotificationMessage from "../../user-message";
import NotificationMessage from "../../modals/notification-message";
import DeliveryUnloadingGroupList from "../../delivery-unloading-group-list";

function HeaderItemLoading({ delivery, dateShipmentRus, regionLoad, nameRegionLastPointUnload }) {
   return (
      <div className="application-topline">
         <div className="application-topline-logist">
            <div className="application-topline-logist-item">
               {/* <div className="application-topline-logist-item-col" style={{ width: "100%" }}>
            <p className="typical-icon-field icon-field-waiting blue-txt">На погрузке</p>
          </div> */}
               <div className="application-topline-carrier-item-col application-topline-carrier-item-col-city">
                  <p className="typical-icon-field icon-field-patch" title={regionLoad}>
                     {regionLoad}
                  </p>
                  <p className="typical-icon-field icon-field-dispatch" title={nameRegionLastPointUnload}>
                     {nameRegionLastPointUnload}
                  </p>
               </div>
            </div>
            <div className="application-topline-logist-item">
               <div className="application-topline-logist-item application-topline-logist-item-determined">
                  <DeterminedPrice delivery={delivery} />
                  <div className="application-topline-logist-item-col application-topline-logist-item-col-date">
                     <div className="typical-icon-field icon-field-calendar">{dateShipmentRus}</div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}

function HeaderItemAwaitingLoading({ delivery, dateShipmentRus, setLoadingDelivItem, setNeedUpdate, regionLoad, nameRegionLastPointUnload }) {
   const accessToSetOnLoading = userServices.getUser().isAccessTo(VIEW_AGREED_DELIVERIES_LOGIST);

   const onClickChangeToLoading = (e) => {
      e.preventDefault();
      setLoadingDelivItem(true);

      deliveriesService
         .changeToLoading(delivery.Id)
         .then((response) => {
            notification.success({
               message: 'Изменение статуса на "На погрузке"',
               description: response.message,
            });

            setLoadingDelivItem(false);
            setNeedUpdate(true);
         })
         .catch((error) => {
            notification.error({
               message: 'Изменение статуса на "На погрузке"',
               description: error,
            });

            setLoadingDelivItem(false);
            setNeedUpdate(true);
         });
   };

   return (
      <div className="application-topline">
         <div className="application-topline-logist">
            <div className="application-topline-logist-item">
               <div className="application-topline-carrier-item-col application-topline-carrier-item-col-city">
                  <p className="typical-icon-field icon-field-patch" title={regionLoad}>
                     {regionLoad}
                  </p>
                  <p className="typical-icon-field icon-field-dispatch" title={nameRegionLastPointUnload}>
                     {nameRegionLastPointUnload}
                  </p>
               </div>
            </div>
            <div className="application-topline-logist-item">
               <div className="application-topline-logist-item application-topline-logist-item-determined">
                  <DeterminedPrice delivery={delivery} />
                  <div className="application-topline-logist-item-col application-topline-logist-item-col-date">
                     <div className="typical-icon-field icon-field-calendar">{dateShipmentRus}</div>
                  </div>
               </div>
               {accessToSetOnLoading ? (
                  <div className="application-topline-logist-item-col application-topline-logist-item-col-button">
                     <button className="btn typical-btn typical-btn-blue typical-btn-l" onClick={onClickChangeToLoading}>
                        Погрузка <div className="typical-btn-icon typical-btn-green-icon" />
                     </button>
                  </div>
               ) : null}
            </div>
         </div>
      </div>
   );
}



export default function LoadingUnloadingPage() {

   const [step, setStep] = useState(deliveriesConfig.pageCount);
   const [offset, setOffset] = useState(0);
   const [currentPage, setCurrentPage] = useState(1);
   const [needUpdate, setNeedUpdate] = useState(true);
   const [data, setData] = useState(null);
   const [loadingScheduleItem, setLoadingScheduleItem] = useState(true);
   const [stopListUpdate, setStopListUpdate] = useState(false);
   const [notifications, setNotifications] = useState(null);
   const [error, setError] = useState(null);


   let loading = (data === null || needUpdate || (notifications === null && true));

   const appContext = useContext(AppContext);

   let onChange = (page, pageSize) => {
      if (page === currentPage) {
         return false;
      } else {
         setCurrentPage(page);
      }

      let val = 0;
      if (parseInt(page) === 1) {
         setOffset(0);
      } else {
         val = page * pageSize - pageSize;
         setOffset(val);
      }
      appContext.filter.offset = val;
      setNeedUpdate(true);
   };

   useEffect(() => {

      Filters.getFilters().then(
         (response) => {
            if (response.From.length || response.To.length) {
               return appContext.enableFilter(Object.values(response.From), Object.values(response.To));
            }
         }
      )

   }, []);

   useEffect(() => {
      let isMounted = true;
      if (needUpdate || appContext.isNeedUpdateUnloadingList) {
         deliveriesService.getLoadingsUnloadings(
            offset,
            step,
            appContext.filter.selectedRegionsLoading,
            appContext.filter.selectedRegionsUnloading,
            appContext.filter.selectedSorting
         )
            .then((response) => {
               if (isMounted) {
                  if (response != null && response.Schedule.length > 0) {
                     response.Schedule = response.Schedule.map((scheduleEntry) => {
                        if (scheduleEntry.OperationType === 'loading') {
                           let delivery = scheduleEntry.Operation;
                           const dateShipmentRus = moment(delivery.dateShipmen).format("D MMMM YYYY");
                           const header = delivery.Status === DELIVERY_AWAITING_LOADING ? HeaderItemAwaitingLoading : HeaderItemLoading;
                           const color = delivery.Status === "loading" ? "" : "red";
                           return (
                              <DeliveryItemBlock
                                 key={`${delivery.Id}_${delivery.Order.Status}`}
                                 header={header}
                                 content={LogistFreeContentItem}
                                 delivery={delivery}
                                 dateShipmentRus={dateShipmentRus}
                                 setNeedUpdate={setNeedUpdate}
                                 setStopListUpdate={setStopListUpdate}
                                 color={color}
                                 permissions={response.Permissions}
                              />
                           )
                        } else if (scheduleEntry.OperationType === 'unloading') {
                           let unloading = scheduleEntry.Operation;

                           return (
                              <UnloadingItemBlock key={`${unloading.Id}_${unloading.Status}`}
                                 unloading={unloading}
                              />

                           )
                        }
                     })
                  }

                  setData(response)
                  setLoadingScheduleItem(false);
                  setNeedUpdate(false);
                  appContext.setIsNeedUpdateUnloadingList(false)
               }
            },
               (error) => {
                  if (isMounted) {
                     setError(error);
                     setNeedUpdate(false);
                     appContext.setIsNeedUpdateUnloadingList(false)
                  }
               }
            )
            .catch((error) => {
               if (isMounted) {
                  setError(error);
                  setNeedUpdate(false);
                  appContext.setIsNeedUpdateUnloadingList(false)
               }
            })
      }

      return () => { isMounted = false }

   }, [needUpdate, appContext.isNeedUpdateUnloadingList]);

   // эффект для применения параметров фильтра
   useEffect(() => {
      if (needUpdate === false) {
         setNeedUpdate(true);
      }
   }, [
      appContext.filter.selectedRegionsLoading,
      appContext.filter.selectedRegionsUnloading,
      appContext.filter.selectedSorting,
   ]);

   return (
      <Spinner loading={loadingScheduleItem}>

         <UserNotificationMessage />
         <NotificationMessage notifications={notifications} setNeedUpdate={false} setStopListUpdate={setStopListUpdate} loading={loading} />
         {
            data != null && data.TotalCount != 0 &&

            <div className="application-block pagination pagination__up">
               <Pagination
                  style={{ textAlign: "center" }}
                  current={currentPage}
                  pageSize={step}
                  total={data.TotalCount}
                  showTotal={(total, range) => `${range[0]}-${range[1]} из ${data.TotalCount} записей`}
                  onChange={onChange}
               />
            </div>

         }
         {
            data !== null && data.Schedule.length > 0 ?
               <DeliveryUnloadingGroupList items={data.Schedule} />
               :
               null
         }
         {
            data != null && data.TotalCount != 0 &&

            <div className="application-block pagination pagination__down">
               <Pagination
                  style={{ textAlign: "center" }}
                  current={currentPage}
                  pageSize={step}
                  total={data.TotalCount}
                  showTotal={(total, range) => `${range[0]}-${range[1]} из ${data.TotalCount} записей`}
                  onChange={onChange}
               />
            </div>
         }

      </Spinner>
   )
}